import { useAuthContext } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export function useAuth() {
  const { 
    user, 
    loading, 
    error, 
    signIn, 
    signOut, 
    signInWithGoogle 
  } = useAuthContext();
  const navigate = useNavigate();

  // Funzioni di utilità per verificare i ruoli
  const isAdmin = user?.role === 'admin';
  const isPizzeria = user?.role === 'pizzeria';

  // Funzione per verificare se il periodo di prova è ancora valido
  const isTrialValid = () => {
    if (!user?.trialStartDate) return false;
    
    const trialStart = new Date(user.trialStartDate);
    const now = new Date();
    const diffDays = Math.floor((now.getTime() - trialStart.getTime()) / (1000 * 60 * 60 * 24));
    
    return diffDays <= (user.trialDays || 0);
  };

  // Funzione per ottenere i giorni rimanenti del trial
  const getRemainingTrialDays = () => {
    if (!user?.trialStartDate) return 0;
    
    const trialStart = new Date(user.trialStartDate);
    const now = new Date();
    const diffDays = Math.floor((now.getTime() - trialStart.getTime()) / (1000 * 60 * 60 * 24));
    
    return Math.max(0, (user.trialDays || 0) - diffDays);
  };

  const handleGoogleSignIn = async () => {
    try {
      const { isNewUser, hasPizzerie } = await signInWithGoogle();
      
      if (isNewUser || (!hasPizzerie && user?.slices === 0)) {
        // Nuovo utente o utente esistente senza pizzerie e spicchi
        navigate('/admin/pizzerie', { 
          state: { 
            showSetup: true,
            showSpicchioOmaggio: true,
            message: isNewUser 
              ? 'Benvenuto! Hai ricevuto uno spicchio omaggio per pubblicare la tua prima pizza!'
              : 'Configura la tua prima pizzeria e ricevi uno spicchio in omaggio!'
          }
        });
      } else {
        navigate(user?.role === 'admin' ? '/admin' : '/admin/pizzerie');
      }
    } catch (err) {
      console.error('Google Sign In Error:', err);
      throw err;
    }
  };

  return {
    user,
    loading,
    error,
    signIn,
    signOut,
    signInWithGoogle,
    isAdmin,
    isPizzeria,
    isTrialValid,
    getRemainingTrialDays,
    handleGoogleSignIn
  };
}